module.exports = __webpack_public_path__ + "static/media/linkedin.9ccbb50a.svg";